import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VehiclePosition } from '../_models/vehiclePosition';
import { Vehicle } from '../_models/vehicle';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getLastPosition(vehicleId: number): Observable<VehiclePosition> {
    return this.http.get<VehiclePosition>(this.baseUrl + 'maps/' + vehicleId);
  }

  getLastPositionByImei(imei: string): Observable<VehiclePosition> {
    return this.http.get<VehiclePosition>(this.baseUrl + 'maps/lastPositionByImei/' + imei);
  }

  getVehicles(date: Date): Observable<Vehicle[]> {
    return this.http.get<Vehicle[]>(this.baseUrl + 'maps/vehicles/' + new Date(date).toJSON());
  }

  getPositions(date: Date, imei: string): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + 'maps/positions/' + new Date(date).toJSON() + '/' + imei);
  }

  getFromToPositions({ dateFrom, dateTo, imei, minVelocity }): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + `maps/positions`, {
      params: {
        searchOptions: JSON.stringify({
          dayFrom: dateFrom,
          dayTo: dateTo,
          imei,
          minVelocity
        })
      }
    });
  }

  getVehiclePositions(clientId: number): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + 'maps/vehiclePositions/' + clientId);
  }

  getVehiclePositions_NEW({ clientId, userId }): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + `maps/vehiclePositions/${clientId}/users/${userId}`);
  }

  getSharedPositionClientsData() {
    return this.http.get<any>(this.baseUrl + `maps/sharedPositions/data/clients`);
  }

  getSharedPositionVehiclesData() {
    return this.http.get<any>(this.baseUrl + `maps/sharedPositions/data/vehicles`);
  }

  getSharedPositionByVehicleId({ clientId, vehicleId, email }) {
    return this.http.get<VehiclePosition>(this.baseUrl + `maps/vehicles/${vehicleId}/sharedPosition`, {
      params: {
        searchOptions: JSON.stringify({ clientId, vehicleId, email })
      }
    });
  }

  getVehiclePositionsOSM(clientId: number): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + 'maps/vehiclePositionsOSM/' + clientId);
  }

  getVehiclePositionsOSM_NEW({ clientId, userId }): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + `maps/vehiclePositionsOSM/${clientId}/users/${userId}`);
  }

  getGroupVehiclePositions(clientId: number, groupId: number): Observable<VehiclePosition[]> {
    return this.http.get<VehiclePosition[]>(this.baseUrl + 'maps/vehicleGroupPositions/' + clientId + '/' + groupId);
  }

  getVehicleGroupPositions_NEW({ clientId, groupId, userId }): Observable<VehiclePosition[]> {
    // this will be deleted
    return this.http.get<VehiclePosition[]>(this.baseUrl + `maps/vehicleGroupPositions/${clientId}/${groupId}/users/${userId}`);
  }

  getPosiionWithAddress(modemType: number, imei: string): Observable<VehiclePosition> {
    return this.http.get<VehiclePosition>(this.baseUrl + 'maps/positionWithAddress/' + modemType + '/' + imei);
  }

  getPositionAddresses(positions: any[], fromIndex: number): Observable<any> {
    return this.http.post<any>(this.baseUrl + 'maps/positions/addresses/' + fromIndex, positions);
  }

  getLogGreska(imei: string): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'maps/log/greska/' + imei);
  }

  getLogSpisak(imei: string): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'maps/log/spisak/' + imei);
  }
  getLogsGreske(imei: string, number: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'maps/logs/greske/' + imei + '/' + number);
  }

  getLogsSpiskovi(imei: string, number: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'maps/logs/spiskovi/' + imei + '/' + number);
  }

  getAllVehiclePositions(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'maps/allVehiclePositions');
  }

  getAddressFromHereApi({ longitude, latitude }): Observable<any> {
    const url = `https://revgeocode.search.hereapi.com/v1/revgeocode?at=${longitude}%2C${latitude}&lang=sr-Latn-CS&apiKey=tHMdcYbXoZ_0P2ag0SB-OLwDmaeE5Un9r8HLXnf5k3I`;
    return this.http.get<any>(url);
  }

  getLastPositionImei(imei: string): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'maps/lastPosition/' + imei);
  }
  // getModemParams(imei: string): Observable<any>  {
  //   return this.http.get<any>(this.baseUrl + 'maps/modem-parameter-show/'+imei);
  // }

  getSharedPositionsByCLientId({ clientId, filter }) {
    return this.http.get<any[]>(this.baseUrl + `maps/clients/${clientId}/sharedPositions`, {
      params: {
        searchOptions: JSON.stringify(filter)
      }
    });
  }

  deleteSharedPositionByFilter({ clientId, filter }) {
    return this.http.delete<void>(this.baseUrl + `maps/clients/${clientId}/sharedPositions`, {
      params: {
        searchOptions: JSON.stringify(filter)
      }
    });     
  }

  createSharedPositionByClientId({ clientId, input }) {
    return this.http.post<void>(this.baseUrl + `maps/clients/${clientId}/sharedPositions`, input);
  }

  updateSharedPositionByClientId({ clientId, input }) {
    return this.http.put<void>(this.baseUrl + `maps/clients/${clientId}/sharedPositions`, input);
  }
}
